import { MonitoringTable } from "@/features/monitoring";
import { Header } from "@/features/standard/Header";
import { Main } from "@/features/standard/Main";
import { HeaderSubTitle } from "@/features/standard/SubTitle";
import { HeaderTitle } from "@/features/standard/Title";
import { Wrapper } from "@/features/standard/Wrapper";

const Monitoring = Object.assign({}, Main, {
  Header: Header,
  HeaderTitle: HeaderTitle,
  HeaderSubTitle: HeaderSubTitle,
  MonitoringWrapper: Wrapper,
  MonitoringTable: MonitoringTable,
});

export const MonitoringPage = () => {
  return (
    <Monitoring.MonitoringWrapper>
      <Monitoring.MonitoringTable />
    </Monitoring.MonitoringWrapper>
  );
};
